const LABELS = {
  lifestyle: "Lifestyle",
  career: "Career",
  family_expectations: "Family",
  location: "Location",
  interests: "Interests",
  future_goals: "Future Goals",
};

export function CompatibilityRing({ score, size = 56 }) {
  const r = (size - 8) / 2;
  const c = 2 * Math.PI * r;
  const off = c - (score / 100) * c;
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }} data-testid="compatibility-ring">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#F1E9DA" strokeWidth="6" />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#C59B27" strokeWidth="6"
          strokeDasharray={c} strokeDashoffset={off} strokeLinecap="round" />
      </svg>
      <span className="absolute font-serif font-bold text-[#58111A]" style={{ fontSize: size * 0.28 }}>{score}%</span>
    </div>
  );
}

export function CompatibilityBreakdown({ breakdown = {} }) {
  return (
    <div className="space-y-3" data-testid="compatibility-breakdown">
      {Object.entries(breakdown).map(([k, v]) => (
        <div key={k}>
          <div className="flex justify-between text-xs font-medium text-[#605255] mb-1">
            <span>{LABELS[k] || k}</span>
            <span className="text-[#781826] font-semibold">{v}%</span>
          </div>
          <div className="h-2 rounded-full bg-[#F1E9DA] overflow-hidden">
            <div className="h-full rounded-full" style={{ width: `${v}%`, background: "linear-gradient(90deg,#C59B27,#781826)" }} />
          </div>
        </div>
      ))}
    </div>
  );
}
